<template>
    <div class="bg-white main">
      <div v-if="tableData.length === 0" style="text-align: center;">
        <img src="~@/assets/img/list_empty.png" style="padding-top: 50px;" />
        <p style="font-size: 16px; padding: 30px; color: #303133;">{{ $t('Publish.ProductList.Components.MTList.FavoriteItem') }}</p>
        <el-button type="primary" style="width: 90%;" @click="jumpProductList">{{ $t('Publish.ProductList.Components.MTList.ChooseProduct') }}</el-button>
      </div>
      <div v-else>
        <div style="padding-left: 0.2rem;">
            <vant-checkbox v-model="isAllSelect" @click="checkChangeAll">{{ $t('Publish.ProductList.Components.MTList.SelectAll') }}</vant-checkbox>
        </div>
        <div style="padding: 0.2rem;" class="product_group">
            <div v-for="item in tableData" :key="item.id" class="product">
              <div class="failReason" v-if="item.synResult">
                  {{ item.synResult}}
              </div>
              <div class="f">
                  <vant-checkbox v-model="item.isChecked" :disabled="item.status === 0" class="checkbox" @change="v => checkChange(v, item)"></vant-checkbox>
                  <div style="margin-right: 0.2rem;"></div>
                  <div class="f product_info" @click="visitDetail(item)">
                  <el-image :src="item.imgUrl" style="width: 1.6rem;height: 1.6rem;" class="image"></el-image>
                  <div class="fontInfo">
                      <p class="ellipsis title">{{ item.productName }}</p>
                      <!-- <p class="gray">{{ typeObjinternational[item.productType] }}</p> -->
                      <p class="gray">{{ $t('Publish.ProductList.Components.MTList.Price') }}: ${{ item.price }}</p>
                      <p class="gray">{{ $t('Publish.ProductList.Components.MTList.Inventory') }}: {{ item.stock }}</p>
                  </div>
                  </div>
              </div>
              <el-divider style="margin: .2rem 0 !important;"></el-divider>
            </div>
        </div>
        <div class="bottomBtn f-a">
            <el-button style="width: 3rem;" @click="deleteHandle">{{ $t('Publish.ProductList.Components.MTList.Delete') }}</el-button>
            <el-button type="primary" style="width: 3rem;" @click="listToStoreHandle">{{ $t('Publish.ProductList.Components.MTList.ListToStore') }}</el-button>
        </div>
      </div>
    </div>
</template>

<script>
import Checkbox from 'vant/lib/checkbox'
import 'vant/lib/checkbox/style'
import API from '@/api'
import Dialog from 'vant/lib/dialog'
import 'vant/lib/dialog/style'
export default {
  components: {
    'vant-checkbox': Checkbox
  },
  props: {
    shippingFromList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isAllSelect: false,
      searchParams: {
        pageNumber: 1,
        pageSize: 20,
        searchNameArrays: []
      },
      tableData: [],
      total: 0
    }
  },
  computed: {
    typeObjinternational() {
      let obj = {
        1: this.$t('productList.customized'),
        2: this.$t('productList.goodsInStock')
      }
      return obj
    },
    selections() {
      let arr = []
      arr = new Set(this.tableData.filter(e => e.isChecked))
      return arr
    }
  },
  created() {
    this.getList()
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('scroll', this.scrollEvent)
    })
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollEvent)
  },
  methods: {
    checkChangeAll(e) {
      this.tableData.forEach(e => {
        this.$set(e, 'isChecked', e.status ? this.isAllSelect : false)
      })
    },
    checkChange(v, item) {
      this.isAllSelect = this.tableData.filter(e => e.status).every(e => e.isChecked)
    },
    getList() {
      const loading = this.$loading.service()
      let params = Object.assign({}, this.searchParams)
      API.publishGetProductList(params).then(res => {
        let newData = res.data.list
        this.tableData = this.tableData.concat(newData)
        console.log(this.tableData)
        this.total = res.data.total
      }).finally(() => {
        loading.close()
      })
    },
    visitDetail(item) {
      console.log(item)
    },
    scrollEvent(e) {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      let windowHeight = document.documentElement.clientHeight || document.body.clientHeight
      let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
      let isBottom = scrollTop + windowHeight - scrollHeight > -20
      if (!isBottom) return
      if (this.tableData.length < this.total) {
        this.searchParams.pageNumber++
        this.getList()
      }
    },
    deleteHandle() {
      const that = this
      Dialog.confirm({
        message: 'Are you sure to delete the checked product?',
        confirmButtonText: 'confirm',
        cancelButtonText: 'cancel'
      })
        .then(() => {
          // on confirm
          let selections = Array.from(that.selections)
          let ids = []
          selections.forEach((v, k) => {
            ids.push(v.kkProductId)
          })
          if (ids.length === 0) return false

          API.deleteProductCollects({ kkProductIds: ids, deleteType: 1 }).then(res => {
            that.$message.success(res.message)
            this.tableData = []
            this.getList()
          }).catch(err => {
            let message = err.message || err.data.message
            that.$message.error(message)
          })
        })
        .catch(() => {
          // on cancel
        })
    },
    listToStoreHandle() {
      let selections = Array.from(this.selections)
      if (selections.length) {
        const spus = selections.map(e => e.spuCode)
        const spusList = []
        const spuCodes = []
        const country = this.shippingFromList
        country.forEach(item => {
          let obj = {
            spu: [],
            countryCode: item.countryCode,
            countryName: item.countryCn
          }
          selections.forEach(s => {
            if (s.countryStockVOList.some(c => c.countryCode === item.countryCode) && !spuCodes.includes(s.spuCode)) {
              obj.spu.push(s.spuCode)
              spuCodes.push(s.spuCode)
            }
          })
          spusList.push(obj)
        })
        let spuCountryDTOList = spusList.filter(item => item.spu.length).map(item => ({ ...item, spu: item.spu.join() }))
        this.$store.commit('published/set', { MTBatchPublishedListSpu: spus })
        this.$store.commit('published/set', { MTBatchSpuCountryDTOList: spuCountryDTOList })
        this.$router.push('/publish/batchPublish')
      }
    },
    jumpProductList() {
      location.href = '/product-list'
    }
  }
}
</script>

<style lang="scss" scoped>
.main {
  padding-bottom: 1.2rem;
  min-width: auto !important;
}
.product_group {
    .product {
    width: 100%;
    position: relative;
    .checkbox {
        // margin-right: 0.2rem;
        flex-shrink: 0;
    }
    .product_info {
        width: calc(100% - .4rem);
        .image {
        flex-shrink: 0;
        width: 1.6rem;
        height: 1.6rem;
        margin-right: .2rem;
        }
        .fontInfo {
        max-width: calc(100% - 2rem);
        .title {
            font-size: .3rem;
            line-height: .6rem;
        }
        .gray{
            color: #7B7B7B;
        }
        }
        .price {
        font-size: .4rem;
        font-weight: 600;
        display: flex;
        align-items: flex-end;
        }
    }
    .failReason {
        // height: 1rem;
        background-color: #DEDEDE42;
        margin: .1rem 0;
        padding: .1rem .2rem;
    }
    /deep/.el-divider--horizontal {
        margin: .4rem 0 .2rem;
    }
    }
}
.bottomBtn {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  box-shadow: 0 -.1rem .1rem #dcdfe6;
  background-color: #fff;
  height: 1.2rem;
  align-items: center;
  >.el-button {
    height: .8rem;
  }
}
</style>
